import moment from "moment";

const start = (date: any) => moment(date).startOf("day").toDate();
const end = (date: any) => moment(date).endOf("day").toDate();
const now = () => moment();
const maxDate = () => moment().endOf("day");

export { now, start, end, maxDate };
